/* Shared dark-themed data table primitive */
export default function DataTable({ columns, rows, empty = "No data", testid, rowKey = (r, i) => r.id || i }) {
  const list = Array.isArray(rows) ? rows : [];
  return (
    <div className="overflow-x-auto" data-testid={testid}>
      <table className="w-full text-[13px]">
        <thead className="bg-[#0A0F1F] text-[#8892A8] text-left text-[11px] uppercase tracking-wider border-b border-[#1E2845]">
          <tr>
            {columns.map((c) => (
              <th
                key={c.key}
                className={`px-5 py-3 font-semibold ${c.align === "right" ? "text-right" : ""}`}
                style={{ width: c.width }}
              >
                {c.header}
              </th>
            ))}
          </tr>
        </thead>
        <tbody className="divide-y divide-[#1E2845]">
          {list.length === 0 ? (
            <tr><td colSpan={columns.length} className="p-10 text-center text-[#8892A8] text-[13px]">{empty}</td></tr>
          ) : list.map((r, i) => (
            <tr key={rowKey(r, i)} className="hover:bg-[#13192C]" data-testid={r._testid}>
              {columns.map((c) => (
                <td key={c.key} className={`px-5 py-3 ${c.align === "right" ? "text-right tabular-nums" : ""} ${c.cls || ""}`}>
                  {c.render ? c.render(r) : r[c.key]}
                </td>
              ))}
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
}
